import { render, staticRenderFns } from "./breadcrumbs navlist.vue?vue&type=template&id=87836ade"
import script from "./breadcrumbs navlist.vue?vue&type=script&lang=js"
export * from "./breadcrumbs navlist.vue?vue&type=script&lang=js"
import style0 from "./breadcrumbs navlist.vue?vue&type=style&index=0&id=87836ade&lang=sass"
import style1 from "./breadcrumbs navlist.vue?vue&type=style&index=1&id=87836ade&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87836ade')) {
      api.createRecord('87836ade', component.options)
    } else {
      api.reload('87836ade', component.options)
    }
    module.hot.accept("./breadcrumbs navlist.vue?vue&type=template&id=87836ade", function () {
      api.rerender('87836ade', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/breadcrumbs navlist.vue"
export default component.exports